import Vue from 'vue';
import App from './Table.vue';

new Vue({
  el: '#app',
  render (h) { return <App /> }
})



// WEBPACK FOOTER //
// ./src/table_module/index.js